import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import chatSendIcon from '../../../shared/assets/icons/chat_send.png';
import styles from './ai-advisor-page.module.css';

export const ChatInput = ({ onSend, isBusy, children }) => {
	const intl = useIntl();
	const [value, setValue] = useState('');
	const inputRef = useRef(null);

	// readOnly (not disabled) keeps focus and the caret while a reply loads;
	// this refocuses after the page loads and after a click on the send button.
	useEffect(() => {
		if (!isBusy) inputRef.current?.focus();
	}, [isBusy]);

	const submit = async () => {
		const text = value;
		setValue('');
		const isSent = await onSend(text);
		if (!isSent) setValue(text);
	};

	const handleKeyDown = e => {
		// Enter that confirms an IME composition must not send the message.
		if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
			e.preventDefault();
			submit();
		}
	};

	return (
		<div className={styles.inputWrapper}>
			<div className={styles.inputContainer}>
				<input
					ref={inputRef}
					type='text'
					className={styles.input}
					placeholder={intl.formatMessage({ id: 'AIAdvisorID5' })}
					value={value}
					onChange={e => setValue(e.target.value)}
					onKeyDown={handleKeyDown}
					readOnly={isBusy}
					aria-busy={isBusy}
				/>
				<button
					type='button'
					className={styles.sendButton}
					onClick={submit}
					disabled={isBusy || !value.trim()}
				>
					<img src={chatSendIcon} alt='Send' className={styles.sendIcon} />
				</button>
				{children}
			</div>
		</div>
	);
};
